<template>
    <div class="cashback-content">
        1.“账户余额”是什么？<br><br>
        账户余额是用户在本平台通过分销或通过参加其它活动取得的收入。<br><br><br>
        2. 什么是结算扣税?<br><br>
        用户在申请提现后的第二个月15日内完成扣税结算。相应收入按照劳务报酬所得申报预缴个人所得税，由平台运营主体（即“宇虹教育科技（上海）有限公司”）为用户进行个税预扣预缴申报。扣税计算请参见<br>
        <a class="url" href="http://www.gerensuodeshui.cn/index_lwbc.html">http://www.gerensuodeshui.cn/index_lwbc.html</a><br><br>
        该部分收入将在次年3月1日至6月30日并入用户综合所得进行个人所得税汇算清缴，享受个税多退少补政策，届时请注意在“个人所得税APP”核实查看。<br><br><br>
        3. 分销收入为什么要缴税？<br><br>
        根据国家税法相关规定，纳税人取得劳务收入需要依法纳税，个人用户由平台履行代扣代缴义务。个人所得税扣缴申报管理办法请参见：<br><br>
        <a class="url" href="http://www.chinatax.gov.cn/chinatax/n363/c21603678/content.html">http://www.chinatax.gov.cn/chinatax/n363/c21603678/content.html</a><br><br>
        机构主体认证帐号所获得的所有收益归机构享有，请注意自行向税务机关进行税务申报。<br><br>
        感谢您为依法纳税做出的贡献，感谢您对本平台的理解和支持。<br><br>
        4. 扣除手续费是什么费用？<br><br>
        因为支付使用的微信/支付宝第三方支付通道，在使用支付通道时，通道方会收取支付通道费用。此外，平台会为您完成收入部分的税收申报工作，因此您的收入会相应扣除 1% 手续费用于支付此间费用成本。<br><br>
        5. 如何提现？提现何时到账？<br><br>
        根据国家相关法律规定，提现前需完成实名认证，若您尚未完成实名认证会自动跳转到实名认证页面。完成实名认证和提现申请后，等下个月的结算日（15日内）之前收入会自动进行结算。结算完成后金额将进入您的微信或支付宝账户中，首次提现需要授权绑定您的微信帐号或支付宝帐号，该微信或支付宝认证身份信息需和实名认证身份信息请保持一致（即都是您本人真实身份信息）。根据流程提示，授权绑定微信或支付宝后您就可以进入提现申请页面。提现申请成功提交后，通常在隔月的15日前可在您的微信或支付宝钱包中收到款项（遇国庆或春节等假期可能会有延迟）。<br><br>
        6. 如何查询提现状态？<br><br>
        请至「我的」-「分销收益」-「提现记录」页面查询提现状态。
    </div>
</template>
<style scoped>
.cashback-content {
    padding: 15px 20px;
    min-height: 100vh;
    text-align: left;
    background-color: #fff;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    font-weight: 500;
    word-wrap: break-word; /* 允许在单词内换行 */
    overflow: hidden;
}

.url {
    color: #0095D9;
    text-decoration: none;
}
</style>